module.exports = __webpack_public_path__ + "static/img/support.1784115679763.png";